/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { LiveManagementCreateLivecarpItemRequest } from './LiveManagementCreateLivecarpItemRequest';

export type LiveManagementCreateLivecarpRequest = {
    title: string;
    titleEn?: string | null;
    titleCn?: string | null;
    startDatetime: string;
    endDatetime: string;
    thumbnailNo?: number | null;
    isUploadThumbnails: boolean;
    imageId?: number | null;
    context: string;
    contextEn?: string | null;
    contextCn?: string | null;
    postDate?: string | null;
    openStatus: LiveManagementCreateLivecarpRequest.openStatus;
    releaseSetting?: LiveManagementCreateLivecarpRequest.releaseSetting;
    livecarpItems?: Array<LiveManagementCreateLivecarpItemRequest>;
};

export namespace LiveManagementCreateLivecarpRequest {

    export enum openStatus {
        EDIT = 'edit',
        RELEASE = 'release',
        CANCEL = 'cancel',
    }

    export enum releaseSetting {
        NOW = 'now',
        DATE = 'date',
    }


}

